const readerTerms = {
  en: {
    singular: 'reader',
    singularTitle: 'Reader',
    plural: 'readers',
    pluralTitle: 'Readers',
  },
  sk: {
    singular: 'výkladca',
    singularTitle: 'Výkladca',
    plural: 'výkladcov',
    pluralTitle: 'Výkladcovia',
  },
  cs: {
    singular: 'vykladač',
    singularTitle: 'Vykladač',
    plural: 'vykladačů',
    pluralTitle: 'Vykladači',
  },
  es: {
    singular: 'lector',
    singularTitle: 'Lector',
    plural: 'lectores',
    pluralTitle: 'Lectores',
  },
  pt: {
    singular: 'consultor',
    singularTitle: 'Consultor',
    plural: 'consultores',
    pluralTitle: 'Consultores',
  },
};

const replacements = {
  en: [
    [/\bTeller Pro\b/g, 'Reader Pro'],
    [/\btellers\b/g, 'readers'],
    [/\bTellers\b/g, 'Readers'],
    [/\bteller\b/g, 'reader'],
    [/\bTeller\b/g, 'Reader'],
  ],
  sk: [
    [/\bTeller Pro\b/g, 'Výkladca Pro'],
    [/\bTelleri\b/g, 'Výkladcovia'],
    [/\bTeller\b/g, 'Výkladca'],
    [/\btellerovi\b/gi, 'výkladcovi'],
    [/\btellerom\b/gi, 'výkladcom'],
    [/\btellerov\b/gi, 'výkladcov'],
    [/\btelleri\b/gi, 'výkladcovia'],
    [/\btellermi\b/gi, 'výkladcami'],
    [/\btellera\b/gi, 'výkladcu'],
    [/\btellerov\b/gi, 'výkladcov'],
    [/\bteller\b/gi, 'výkladca'],
  ],
  cs: [
    [/\bTeller Pro\b/g, 'Vykladač Pro'],
    [/\bTeller\b/g, 'Vykladač'],
    [/\btellerovi\b/gi, 'vykladači'],
    [/\btellerům\b/gi, 'vykladačům'],
    [/\btellerů\b/gi, 'vykladačů'],
    [/\btellery\b/gi, 'vykladače'],
    [/\btellerem\b/gi, 'vykladačem'],
    [/\btellera\b/gi, 'vykladače'],
    [/\bteller\b/gi, 'vykladač'],
  ],
  es: [
    [/\bTellers\b/g, 'Lectores'],
    [/\btellers\b/g, 'lectores'],
    [/\bTeller\b/g, 'Lector'],
    [/\bteller\b/g, 'lector'],
  ],
  pt: [
    [/\bTellers\b/g, 'Consultores'],
    [/\btellers\b/g, 'consultores'],
    [/\bTeller\b/g, 'Consultor'],
    [/\bteller\b/g, 'consultor'],
  ],
};

export const getReaderTerms = (language = 'en') => readerTerms[language] || readerTerms.en;

export const localizeReaderText = (value, language = 'en') => {
  if (typeof value === 'string') {
    return (replacements[language] || replacements.en).reduce(
      (text, [pattern, replacement]) => text.replace(pattern, replacement),
      value,
    );
  }
  if (Array.isArray(value)) return value.map((item) => localizeReaderText(item, language));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, localizeReaderText(item, language)]),
    );
  }
  return value;
};
